"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCardPayment = void 0;
var legacy_queries_1 = require("../../../shared/api/legacy-queries");
//currently only legacy is in use - naming is in preparation of future kapi migration
//and follows the pattern used in similar in between stages in the past
var useCardPayment = function (accountId) {
    var latestBillingQueryResult = (0, legacy_queries_1.useBillingLegacyQuery)(accountId, 'latest');
    var billablePeriodsQueryResult = (0, legacy_queries_1.useBillablePeriodsLegacyQuery)(accountId);
    var recommendedDirectDebitResult = (0, legacy_queries_1.useRecommendedDirectDebitLegacyQuery)(accountId);
    //copied the exact same logic as before where fetching and no-data where treated as the same
    var legacyLoading = latestBillingQueryResult.status === 'no-data' ||
        billablePeriodsQueryResult.status === 'no-data' ||
        recommendedDirectDebitResult.status === 'no-data' ||
        latestBillingQueryResult.isFetching ||
        billablePeriodsQueryResult.isFetching ||
        recommendedDirectDebitResult.isFetching;
    //error is currently not used in the UI - this is to follow the pattern of hooks and for future reference if needed
    var legacyError = latestBillingQueryResult.status === 'error'
        ? latestBillingQueryResult.error
        : billablePeriodsQueryResult.status === 'error'
            ? billablePeriodsQueryResult.error
            : recommendedDirectDebitResult.status === 'error'
                ? recommendedDirectDebitResult.error
                : undefined;
    var legacyData = {
        billing: latestBillingQueryResult.status === 'data'
            ? latestBillingQueryResult.data
            : undefined,
        billablePeriods: billablePeriodsQueryResult.status === 'data'
            ? billablePeriodsQueryResult.data
            : undefined,
        recommendedDirectDebit: recommendedDirectDebitResult.status === 'data' &&
            !latestBillingQueryResult.isFetching
            ? recommendedDirectDebitResult.data
            : undefined,
    };
    return {
        loading: legacyLoading,
        error: legacyError,
        data: legacyData,
    };
};
exports.useCardPayment = useCardPayment;
